// modal 표출/미표출 값 저장 변수
import { atom } from 'recoil';

/**
 * @desc 모달 변수
 */
export const modalVisibleState = atom({
  key: 'modalVisibleState',
  default: {
    isopen: false,
    modalType: '',
    modalName: '',
  },
});

/**
 * @desc 팝업 버튼 변수
 */
export const popupButtonVisibleState = atom({
  key: 'popupButtonVisibleState',
  default: {
    isopen: false,
    type: '',
  },
});

export const loginBeforePageState = atom({
  key: 'loginBeforePageState',
  default: '',
});

export const tooltipVisibleState = atom({
  key: 'tooltipVisibleState',
  default: {
    names: [],
    visible: false,
  },
});

export const failedRequestsQueueState = atom({
  key: 'failedRequestsQueueState',
  default: [],
});

export const scrollState = atom({
  key: 'scrollState',
  default: false,
});

/**
 * @desc 토스트 변수
 */
export const toastState = atom({
  key: 'toastState',
  default: {
    visible: false,
    severity: 'info',
    detail: '',
  },
});
